/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { MessageSimple } from './TaskMessageSimple';
import { Message } from './messageTypes';

export type MessageType = Message;
interface MessageProps<MessageType> {
  message: MessageType;
  loading?: boolean;
}

export type TaskMessageTypeMap = {
  [key in Message['type']]: (props: MessageProps<MessageType>) => JSX.Element;
};

export const TaskMessageTypeMap: TaskMessageTypeMap = {
  simple: props => <MessageSimple {...props} />,
  image: props => <MessageSimple {...props} />,
};
